module.exports = __webpack_public_path__ + "img/0-130.2516d8d9.jpg";